export const fixAllPlanosTrabalhoIndex = (planos) => {
  return planos.map((planoItem, planoIndex) => {
    return {
      ...planoItem,
      index: planoIndex,
    };
  });
};

export const fixAllAtividadesIndex = (atividades) => {
  return atividades.map((atividadeItem, atividadeIndex) => {
    return {
      ...atividadeItem,
      index: atividadeIndex,
    };
  });
};
